import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

function reduced(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches
}

/** Whether the person asked for less motion (SA-1315): follows the setting as it changes. */
export function useReducedMotion(): boolean {
  const [value, setValue] = useState(reduced)
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const list = window.matchMedia(QUERY)
    const onChange = () => setValue(list.matches)
    onChange()
    list.addEventListener?.('change', onChange)
    return () => list.removeEventListener?.('change', onChange)
  }, [])
  return value
}
